import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  "en": {
    "translation": {
      "home": "Home",
      "lic_plans": "LIC Plans",
      "child_plans": "Child Plans",
      "pension_plans": "Pension & Retirement",
      "health_plans": "Health Plans",
      "health_insurance": "HDFC Health Plans",
      "nri_insurance": "NRI Insurance",
      "insurance_guides": "Guides & Blog",
      "about": "About V. S. Reddy",
      "contact": "Contact & Visit",
      "call_now": "Call Now",
      "get_a_quote": "Get a Quote",
      "quote": "Quote",
      "trusted_since_2000": "Trusted since 2000",
      "years_experience": "25+ Years Experience",
      "advisor_title": "Senior Insurance Advisor",
      "advisor_sub": "V. S. Reddy • SVR LIC Services",
      "switch_to_telugu": "తెలుగు",
      "switch_to_english": "English",
      "nri_calculator": "NRI Health Calculator",
      "trusted_guidance": "Trusted Insurance Guidance Since 2000",
      "protect_tomorrow_1": "Protect Your Family's",
      "protect_tomorrow_2": "Tomorrow, Today.",
      "expert_advisory": "Expert insurance advisory on sovereign-backed LIC life & pension policies and HDFC ERGO health plans. Tailored for Indian residents and global NRIs.",
      "get_expert_advice": "Get Expert Advice",
      "whatsapp_us": "WhatsApp Us",
      "schedule_free_consultation": "Schedule Free Consultation",
      "or": "or",
      "whatsapp_expert": "WhatsApp Advisor",
      "years_trust": "25+ Years of Trust",
      "happy_families": "10,000+ Families Protected",
      "claim_ratio": "100% Claim Assistance",
      "support_24_7": "24/7 Personal Advisory",
      "claims_settled": "Claims Settled Successfully",
      "families_protected": "Happy Families Protected",
      "claim_support": "Claim Assistance",
      "available_support": "Doorstep & Digital Support",
      "elite_lic": "Sovereign-Backed LIC Life & Pension Plans",
      "secure_legacy": "Secure your family's future with 100% sovereign government-backed life insurance and guaranteed pension policies.",
      "explore_all_lic": "Explore All LIC Plans",
      "view_all_lic": "View All LIC Plans",
      "complete_health_protection": "Complete HDFC ERGO Health Insurance",
      "medical_emergencies_desc": "Safeguard your family against escalating medical bills with HDFC ERGO comprehensive health plans. Zero room rent capping and 4X cover multiplier.",
      "cashless_hospitals_10k": "14,000+ Cashless Hospitals",
      "no_claim_bonus_multiplier": "4X Cover & Restore Benefit",
      "view_health_policies": "View All Health Policies",
      "view_all_hdfc": "View HDFC ERGO Health Plans",
      "protect_family": "Family Protection & Term",
      "wealth_creation": "Wealth Creation & Savings",
      "children_future": "Child Education & Marriage",
      "retirement_planning": "Guaranteed Pension & Retirement",
      "cover_amount": "Coverage Range",
      "cover_range": "Coverage Range",
      "monthly_prem": "Starting Premium",
      "view_plan": "View Policy Details",
      "details": "Details",
      "view_details": "View Details",
      "read_article": "Read Article",
      "min_age": "Minimum Age",
      "max_age": "Maximum Age",
      "policy_term": "Policy Term",
      "premium_term": "Premium Term",
      "key_benefits": "Key Benefits",
      "limitations": "Limitations & Waiting Periods",
      "eligibility": "Eligibility Criteria",
      "advisor_notes": "Advisor Recommendation",
      "share_policy": "Share via WhatsApp",
      "expert_planning_difference": "Expert Planning Makes All The Difference",
      "skip_generic": "Avoid confusing call centers and algorithmic aggregators. Work directly with V. S. Reddy, a seasoned advisor with 25+ years of real claim settlement experience.",
      "try_nri_calculator": "Try NRI Calculator",
      "proven_guidance": "Over 25 years of proven guidance helping families protect wealth and plan for retirement.",
      "search_lic_plans": "Search LIC plans (e.g. Jeevan Utsav, Amrit Baal, Anand)...",
      "search_health_plans": "Search health plans (e.g. Optima Secure, Senior, Diabetes)...",
      "lic_life_insurance_plans": "LIC Life Insurance & Pension Plans",
      "lic_plans_desc": "Explore government-backed life policies designed for guaranteed wealth accumulation, lifelong pension, and family protection.",
      "hdfc_health_plans": "HDFC ERGO Health Insurance Plans",
      "hdfc_desc": "Award-winning comprehensive health insurance plans to safeguard you and your loved ones from medical emergencies.",
      "no_plans_found": "No policies found matching your search. Please try another search term.",
      "clear_search": "Clear Search",
      "verified_claims_settled": "Recent Claims & Settlements Handled",
      "settled": "Settled",
      "need_help": "Need Guidance Choosing the Right Policy?",
      "experts_ready": "Senior Advisor V. S. Reddy is ready to analyze your family's financial needs and provide customized illustrations at no obligation.",
      "request_callback": "Request Free Consultation",
      "call_button": "Call +91-9849664800",
      "whatsapp_now": "WhatsApp Now",
      "trust_behind_name": "The Trust Behind The Name",
      "vision_desc": "VSR Insurance Plus was founded on a singular principle: absolute transparency, lifetime claim support, and personalized financial security for every family.",
      "senior_lic_advisor": "Senior Insurance Advisor • 25+ Years Experience Since 2000",
      "quarter_century": "A Quarter Century of Financial Protection",
      "guide_light_desc": "For over 25 years, V. S. Reddy has guided families and NRIs in building guaranteed wealth, planning children's higher education, and ensuring stress-free retirements. Based in Hyderabad and serving clients across India and globally.",
      "core_pillars": "Our Core Values",
      "absolute_transparency": "Absolute Transparency",
      "transparency_desc": "No hidden terms or exaggerated returns. Every policy feature is explained with verified documentation and clear numbers.",
      "personal_attention": "Direct Advisor Access",
      "attention_desc": "No junior call center agents. You deal directly with senior advisor V. S. Reddy from initial consultation to policy issuance and claim settlement.",
      "lifelong_service": "Lifelong Claim Advocacy",
      "service_desc": "From the day your policy begins to maturity or claim settlement, our office handles documentation and branch coordination completely.",
      "schedule_consultation": "Schedule Free Consultation",
      "lets_start_planning": "Schedule a Free Consultation",
      "contact_desc": "Reach out to V. S. Reddy for personalized advice on LIC life & pension plans and HDFC ERGO health insurance. Doorstep visits available across Hyderabad.",
      "direct_contact": "Direct Advisor Contact",
      "call_whatsapp": "Call / WhatsApp Direct",
      "email_inquiries": "Official Email",
      "office": "Head Office",
      "are_you_nri": "Are You an NRI Living Abroad?",
      "nri_desc": "We specialize in LIC Mail Order Business (MOB). Complete medicals, KYC, and electronic policy issuance without flying to India.",
      "send_message": "Send a Message",
      "your_name": "Full Name",
      "phone_number": "Phone Number",
      "email_address": "Email Address",
      "how_can_we_help": "How can we assist you?",
      "send_message_btn": "Submit Inquiry",
      "message_sent": "Thank You! Your message has been received.",
      "will_reach_out": "Advisor V. S. Reddy will contact you personally within 24 hours.",
      "send_another": "Send another inquiry",
      "quick_links": "Quick Links",
      "our_services": "Insurance Categories",
      "international_policies": "NRI Insurance Services",
      "contact_us": "Contact & Visit",
      "pan_india_service": "Hyderabad & PAN-India Advisory",
      "international_services": "Global NRI Advisory (USA, UAE, UK, SG)",
      "disclaimer": "Statutory Disclaimer",
      "privacy_policy": "Privacy Policy",
      "terms_of_service": "Terms of Service",
      "all_rights_reserved": "All rights reserved.",
      "regulatory_notice": "Insurance is a subject matter of solicitation. VSR Insurance Plus operates as an independent insurance advisory guided by V. S. Reddy. Life insurance policies are issued by Life Insurance Corporation of India (LIC). Health insurance policies are issued by HDFC ERGO General Insurance Company. Under Section 41 of the Insurance Act 1938, prohibition of rebates is strictly enforced."
    }
  },
  "te": {
    "translation": {
      "home": "హోమ్",
      "lic_plans": "ఎల్‌ఐసి పాలసీలు",
      "child_plans": "పిల్లల పాలసీలు",
      "pension_plans": "పెన్షన్ & రిటైర్‌మెంట్",
      "health_plans": "హెల్త్ పాలసీలు",
      "health_insurance": "హెచ్‌డిఎఫ్‌సి హెల్త్ పాలసీలు",
      "nri_insurance": "ఎన్‌ఆర్‌ఐ బీమా",
      "insurance_guides": "బీమా గైడ్లు & బ్లాగ్",
      "about": "వి. ఎస్. రెడ్డి గారి గురించి",
      "contact": "సంప్రదించండి",
      "call_now": "కాల్ చేయండి",
      "get_a_quote": "కొటేషన్ పొందండి",
      "quote": "కొటేషన్",
      "trusted_since_2000": "2000 నుండి విశ్వసనీయ సేవలు",
      "years_experience": "25+ సంవత్సరాల అనుభవం",
      "advisor_title": "సీనియర్ ఇన్సూరెన్స్ అడ్వైజర్",
      "advisor_sub": "వి. ఎస్. రెడ్డి • ఎస్‌విఆర్ ఎల్‌ఐసి సర్వీసెస్",
      "switch_to_telugu": "తెలుగు",
      "switch_to_english": "English",
      "nri_calculator": "ఎన్‌ఆర్‌ఐ హెల్త్ కాలిక్యులేటర్",
      "trusted_guidance": "2000 నుండి విశ్వసనీయ బీమా సలహాలు",
      "protect_tomorrow_1": "మీ కుటుంబ భవిష్యత్తుకు",
      "protect_tomorrow_2": "నేడే సంపూర్ణ రక్షణ.",
      "expert_advisory": "కేంద్ర ప్రభుత్వ సార్వభౌమ హామీ గల ఎల్‌ఐసి జీవిత బీమా & పెన్షన్ ప్లాన్లు మరియు హెచ్‌డిఎఫ్‌సి ఎర్గో ఆరోగ్య బీమాపై నిపుణుల సలహాలు. హైదరాబాద్, భారత్ మరియు విదేశీ ఎన్‌ఆర్‌ఐల కోసం.",
      "get_expert_advice": "ఉచిత సలహా పొందండి",
      "whatsapp_us": "వాట్సాప్ చేయండి",
      "schedule_free_consultation": "ఉచిత కన్సల్టేషన్ బుక్ చేయండి",
      "or": "లేదా",
      "whatsapp_expert": "అడ్వైజర్‌తో వాట్సాప్ చాట్",
      "years_trust": "25+ సంవత్సరాల నమ్మకం",
      "happy_families": "10,000+ కుటుంబాల రక్షణ",
      "claim_ratio": "100% క్లెయిమ్ సహాయం",
      "support_24_7": "24/7 వ్యక్తిగత సలహా",
      "claims_settled": "విజయవంతంగా పరిష్కరించిన క్లెయిమ్‌లు",
      "families_protected": "సంతృప్త కుటుంబాలు",
      "claim_support": "క్లెయిమ్ సహాయం",
      "available_support": "ఇంటి వద్దకే & డిజిటల్ సేవలు",
      "elite_lic": "ప్రభుత్వ హామీ గల ఎల్‌ఐసి పాలసీలు",
      "secure_legacy": "100% కేంద్ర ప్రభుత్వ సార్వభౌమ హామీతో మీ కుటుంబానికి ఆర్థిక రక్షణ మరియు జీవితాంతం పెన్షన్ భరోసా కల్పించండి.",
      "explore_all_lic": "అన్ని ఎల్‌ఐసి పాలసీలు చూడండి",
      "view_all_lic": "అన్ని ఎల్‌ఐసి ప్లాన్లు",
      "complete_health_protection": "హెచ్‌డిఎఫ్‌సి ఎర్గో సంపూర్ణ ఆరోగ్య బీమా",
      "medical_emergencies_desc": "ఆకస్మిక ఆసుపత్రి ఖర్చుల నుండి మీ ఆస్తులను కాపాడుకోండి. హెచ్‌డిఎఫ్‌సి ఎర్గోలో రూమ్ రెంట్ పరిమితులు లేని చికిత్స మరియు 4 రెట్ల కవరేజ్.",
      "cashless_hospitals_10k": "14,000+ క్యాష్‌లెlevel ఆసుపత్రులు",
      "no_claim_bonus_multiplier": "4 రెట్ల కవరేజ్ & రీస్టోర్ బెనిఫిట్",
      "view_health_policies": "అన్ని హెల్త్ పాలసీలు చూడండి",
      "view_all_hdfc": "హెచ్‌డిఎఫ్‌సి ఎర్గో హెల్త్ ప్లాన్లు",
      "protect_family": "కుటుంబ రక్షణ & టర్మ్ బీమా",
      "wealth_creation": "సంపద సృష్టి & పొదుపు పథకాలు",
      "children_future": "పిల్లల చదువు & వివాహ ప్రణాళిక",
      "retirement_planning": "గ్యారెంటీడ్ పెన్షన్ & రిటైర్‌మెంట్",
      "cover_amount": "కవరేజ్ పరిమితి",
      "cover_range": "కవరేజ్ పరిమితి",
      "monthly_prem": "ప్రారంభ ప్రీమియం",
      "view_plan": "పాలసీ వివరాలు చూడండి",
      "details": "వివరాలు",
      "view_details": "వివరాలు చూడండి",
      "read_article": "వ్యాసం చదవండి",
      "min_age": "కనిష్ట వయస్సు",
      "max_age": "గరిష్ట వయస్సు",
      "policy_term": "పాలసీ కాల పరిమితి",
      "premium_term": "ప్రీమియం చెల్లింపు కాలం",
      "key_benefits": "ముఖ్య ప్రయోజనాలు",
      "limitations": "పరిమితులు & వెయిటింగ్ పీరియడ్",
      "eligibility": "అర్హత ప్రమాణాలు",
      "advisor_notes": "అడ్వైజర్ సలహా",
      "share_policy": "వాట్సాప్‌లో షేర్ చేయండి",
      "expert_planning_difference": "నిపుణుల సరైన ప్రణాళికతోనే సంపూర్ణ ఆర్థిక భద్రత",
      "skip_generic": "కాల్ సెంటర్లు, ఆన్‌లైన్ బోట్‌ల అయోమయం వద్దు. 25 సంవత్సరాల వాస్తవ క్లెయిమ్ అనుభవం గల సీనియర్ అడ్వైజర్ వి. ఎస్. రెడ్డి గారితో నేరుగా మాట్లాడండి.",
      "try_nri_calculator": "ఎన్‌ఆర్‌ఐ కాలిక్యులేటర్ చూడండి",
      "proven_guidance": "25 సంవత్సరాలుగా వేలాది కుటుంబాలకు సంపద సృష్టి మరియు రిటైర్‌మెంట్ ప్లానింగ్‌లో అండగా నిలిచిన సేవలు.",
      "search_lic_plans": "ఎల్‌ఐసి ప్లాన్ల కోసం వెతకండి (ఉదా: జీవన్ ఉత్సవ్, అమృతబాల్, ఆనంద్)...",
      "search_health_plans": "హెల్త్ ప్లాన్ల కోసం వెతకండి (ఉదా: ఆప్టిమా సెక్యూర్, సీనియర్)...",
      "lic_life_insurance_plans": "ఎల్‌ఐసి జీవిత బీమా & పెన్షన్ పాలసీలు",
      "lic_plans_desc": "హామీతో కూడిన సంపద వృద్ధి, జీవితాంతం పెన్షన్ మరియు కుటుంబ రక్షణ కోసం ప్రభుత్వ హామీ గల పథకాలను పరిశీలించండి.",
      "hdfc_health_plans": "హెచ్‌డిఎఫ్‌సి ఎర్గో ఆరోగ్య బీమా పథకాలు",
      "hdfc_desc": "వైద్య అత్యవసర సమయాల్లో మిమ్మల్ని మరియు మీ కుటుంబాన్ని కాపాడే భారతదేశపు అత్యుత్తమ సమగ్ర ఆరోగ్య బీమా పథకాలు.",
      "no_plans_found": "మీ వెతుకులాటకు సరిపోలే పాలసీలు కనుగొనబడలేదు. దయచేసి వేరే పదం ప్రయత్నించండి.",
      "clear_search": "వెతుకులాటను తొలగించండి",
      "verified_claims_settled": "ఇటీవల పరిష్కరించిన వాస్తవ క్లెయిమ్‌లు",
      "settled": "క్లెయిమ్ పరిష్కారం",
      "need_help": "మీ కుటుంబానికి సరైన పాలసీ ఎంపికలో సహాయం కావాలా?",
      "experts_ready": "సీనియర్ అడ్వైజర్ వి. ఎస్. రెడ్డి గారు మీ అవసరాలకు తగినట్లుగా ఎలాంటి రుసుము లేకుండా ఉచితంగా విశ్లేషణ అందిస్తారు.",
      "request_callback": "ఉచిత సలహా కోసం సంప్రదించండి",
      "call_button": "కాల్: +91-9849664800",
      "whatsapp_now": "వాట్సాప్ మెసేజ్ చేయండి",
      "trust_behind_name": "పేరు వెనుక ఉన్న నమ్మకం",
      "vision_desc": "విఎస్‌ఆర్ ఇన్సూరెన్స్ ప్లస్ ఏకైక లక్ష్యం: సంపూర్ణ పారదర్శకత, జీవితాంతం క్లెయిమ్ సేవలు మరియు ప్రతి కుటుంబానికి తిరుగులేని ఆర్థిక రక్షణ.",
      "senior_lic_advisor": "సీనియర్ ఇన్సూరెన్స్ అడ్వైజర్ • 2000 నుండి 25+ ఏళ్ల అనుభవం",
      "quarter_century": "పాతికేళ్ల పాటు వేలాది కుటుంబాలకు ఆర్థిక రక్షణ",
      "guide_light_desc": "25 సంవత్సరాలుగా వి. ఎస్. రెడ్డి గారు కుటుంబాలు మరియు ఎన్‌ఆర్‌ఐలకు సంపద వృద్ధి, పిల్లల ఉన్నత చదువులు మరియు గౌరవప్రదమైన రిటైర్‌మెంట్ ప్రణాళికలో మార్గదర్శిగా నిలిచారు.",
      "core_pillars": "మా మూల స్తంభాలు",
      "absolute_transparency": "సంపూర్ణ పారదర్శకత",
      "transparency_desc": "దాగి ఉన్న నిబంధనలు లేదా తప్పుడు హామీలు ఉండవు. ప్రతి పాలసీ ప్రయోజనాన్ని స్పష్టమైన గణాంకాలతో వివరిస్తాము.",
      "personal_attention": "నేరుగా అడ్వైజర్ సేవలు",
      "attention_desc": "కాల్ సెంటర్లు కాదు; సీనియర్ అడ్వైజర్ వి. ఎస్. రెడ్డి గారే స్వయంగా పాలసీ ఎంపిక నుండి క్లెయిమ్ వరకు మీకు అందుబాటులో ఉంటారు.",
      "lifelong_service": "జీవితాంతం క్లెయిమ్ అండ",
      "service_desc": "పాలసీ తీసుకున్న రోజు నుండి మెచ్యూరిటీ లేదా క్లెయిమ్ వచ్చేంత వరకు డాక్యుమెంటేషన్ బాధ్యతను మా కార్యాలయమే పూర్తిగా చూసుకుంటుంది.",
      "schedule_consultation": "ఉచిత కన్సల్టేషన్ బుక్ చేయండి",
      "lets_start_planning": "ఉచిత కన్సల్టేషన్ బుక్ చేయండి",
      "contact_desc": "ఎల్‌ఐసి మరియు హెచ్‌డిఎఫ్‌సి ఎర్గో పాలసీలపై వ్యక్తిగత సలహాల కోసం సంప్రదించండి. హైదరాబాద్‌లో ఇంటి వద్దకే సేవలు అందుబాటులో ఉన్నాయి.",
      "direct_contact": "అడ్వైజర్ నేరుగా సంప్రదింపు",
      "call_whatsapp": "కాల్ / వాట్సాప్ నంబర్",
      "email_inquiries": "అధికారిక ఈమెయిల్",
      "office": "ప్రధాన కార్యాలయం",
      "are_you_nri": "మీరు విదేశాల్లో నివసిస్తున్న ఎన్‌ఆర్‌ఐ (NRI) నా?",
      "nri_desc": "ఎల్‌ఐసి మెయిల్ ఆర్డర్ బిజినెస్ (MOB) ద్వారా భారత్‌కు రాకుండానే ఆన్‌లైన్‌లో సురక్షితంగా పాలసీ పొందే ప్రత్యేక సదుపాయం.",
      "send_message": "సందేశం పంపండి",
      "your_name": "మీ పూర్తి పేరు",
      "phone_number": "ఫోన్ నంబర్",
      "email_address": "ఈమెయిల్ చిరునామా",
      "how_can_we_help": "మేము మీకు ఎలా సహాయపడగలము?",
      "send_message_btn": "సందేశం పంపండి",
      "message_sent": "ధన్యవాదాలు! మీ వివరాలు అందాయి.",
      "will_reach_out": "అడ్వైజర్ వి. ఎస్. రెడ్డి గారు 24 గంటల్లో మిమ్మల్ని స్వయంగా సంప్రదిస్తారు.",
      "send_another": "మరో సందేశం పంపండి",
      "quick_links": "ముఖ్యమైన లింకులు",
      "our_services": "బీమా విభాగాలు",
      "international_policies": "ఎన్‌ఆర్‌ఐ బీమా సేవలు",
      "contact_us": "సంప్రదించండి",
      "pan_india_service": "హైదరాబాద్ & అఖిల భారత సేవలు",
      "international_services": "గ్లోబల్ ఎన్‌ఆర్‌ఐ సేవలు (USA, UAE, UK, SG)",
      "disclaimer": "చట్టబద్ధమైన నిబంధనలు",
      "privacy_policy": "గోప్యతా విధానం",
      "terms_of_service": "నిబంధనలు & షరతులు",
      "all_rights_reserved": "సర్వహక్కులు ప్రత్యేకించబడ్డాయి.",
      "regulatory_notice": "బీమా అనేది ఒక అభ్యర్థన విషయం. విఎస్‌ఆర్ ఇన్సూరెన్స్ ప్లస్ అనేది వి. ఎస్. రెడ్డి గారిచే నడపబడుతున్న స్వతంత్ర సలహా సంస్థ. జీవిత బీమా పాలసీలు లైఫ్ ఇన్సూరెన్స్ కార్పొరేషన్ ఆఫ్ ఇండియా (LIC) ద్వారా మరియు ఆరోగ్య బీమా పాలసీలు హెచ్‌డిఎఫ్‌సి ఎర్గో జనరల్ ఇన్సూరెన్స్ కంపెనీ ద్వారా జారీ చేయబడతాయి. ఇన్సూరెన్స్ చట్టం 1938 సెక్షన్ 41 ప్రకారం ప్రీమియంలపై రాయితీలు ఇవ్వడం లేదా ఆశించడం చట్టరీత్యా నేరం."
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    lng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
